module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 1")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstText),
      expression: "scenario.parameters.questionFirstText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionFirstText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionFirstText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionFirstId', 'questionFirstAudio', 'currentSpeakerFirst', 'questionFirstGeneratedAudio', 'questionFirstText', 'questionFirstLoading', 'First question', 'currentEmotionFirst', 'currentSpeedFirst')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionFirstLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n              Сгенерировать аудио\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerFirst),
      expression: "tmp.currentSpeakerFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                  " + _vm._s(speaker.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionFirst),
      expression: "tmp.currentEmotionFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                  " + _vm._s(emotion.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedFirst,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedFirst = $event
      }
    }
  }), _vm._v("\n              Скорость: " + _vm._s(_vm.tmp.currentSpeedFirst) + "\n            ")], 1), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionFirstLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionFirstLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionFirstLoadedAudio', 'questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', 'onQuestionFirst')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionFirstId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer positive-scenario"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 2 / Сообщение (При ответе Да на Вопрос 1)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesText),
      expression: "scenario.parameters.questionSecondYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondYesId', 'questionSecondYesAudio', 'currentSpeakerSecondYes', 'questionSecondYesGeneratedAudio', 'questionSecondYesText', 'questionSecondYesLoading', 'Second yes question', 'currentEmotionSecondYes', 'currentSpeedSecondYes')
      }
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.tmp.questionSecondYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYes),
      expression: "tmp.currentSpeakerSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                     " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYes),
      expression: "tmp.currentEmotionSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYes = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYes) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondYesLoadedAudio', 'questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', 'onQuestionSecondYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('collapse', [_c('collapse-item', {
    staticClass: "positive-scenario",
    attrs: {
      "title": "Отправить СМС",
      "selected": _vm.scenario.parameters.questionSecondYesSMSText != ''
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesSMSText),
      expression: "scenario.parameters.questionSecondYesSMSText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesSMSText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesSMSText", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('collapse', [_c('collapse-item', {
    staticClass: "second-layer positive-scenario",
    attrs: {
      "title": "Сообщение при ответе Да на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondYesYesId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesGenerationState),
      expression: "scenario.parameters.questionSecondYesYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesYesGenerationState', 'questionSecondYesYesAudio', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesLoadedAudio', 'onQuestionSecondYesYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesGenerationState),
      expression: "scenario.parameters.questionSecondYesYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesYesGenerationState', 'questionSecondYesYesAudio', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesLoadedAudio', 'onQuestionSecondYesYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesText),
      expression: "scenario.parameters.questionSecondYesYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondYesYesId', 'questionSecondYesYesAudio', 'currentSpeakerSecondYesYes', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesText', 'questionSecondYesYesLoading', 'Second yes yes question', 'currentEmotionSecondYesYes', 'currentSpeedSecondYesYes')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondYesYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYesYes),
      expression: "tmp.currentSpeakerSecondYesYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYesYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                       " + _vm._s(speaker.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYesYes),
      expression: "tmp.currentEmotionSecondYesYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYesYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                        " + _vm._s(emotion.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYesYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYesYes = $event
      }
    }
  }), _vm._v("\n                    Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYesYes) + "\n                  ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondYesYesLoadedAudio', 'questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'Second yes yes question', 'onQuestionSecondYesYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'Second yes yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'questionSecondYesYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('collapse', [_c('collapse-item', {
    staticClass: "positive-scenario",
    attrs: {
      "title": "Отправить СМС",
      "selected": _vm.scenario.parameters.questionSecondYesYesSMSText != ''
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesSMSText),
      expression: "scenario.parameters.questionSecondYesYesSMSText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesYesSMSText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesYesSMSText", $event.target.value)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('collapse-item', {
    staticClass: "second-layer negative-scenario",
    attrs: {
      "title": "Сообщение при ответе Нет на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondYesNoId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesNoGenerationState),
      expression: "scenario.parameters.questionSecondYesNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesNoGenerationState', 'questionSecondYesNoAudio', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoLoadedAudio', 'onQuestionSecondYesNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesNoGenerationState),
      expression: "scenario.parameters.questionSecondYesNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesNoGenerationState', 'questionSecondYesNoAudio', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoLoadedAudio', 'onQuestionSecondYesNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesNoText),
      expression: "scenario.parameters.questionSecondYesNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondYesNoId', 'questionSecondYesNoAudio', 'currentSpeakerSecondYesNo', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoText', 'questionSecondYesNoLoading', 'Second yes no question', 'currentEmotionSecondYesNo', 'currentSpeedSecondYesNo')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondYesNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYesNo),
      expression: "tmp.currentSpeakerSecondYesNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYesNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYesNo),
      expression: "tmp.currentEmotionSecondYesNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYesNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYesNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYesNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYesNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondYesNoLoadedAudio', 'questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'Second yes no question', 'onQuestionSecondYesNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'Second yes no question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'questionSecondYesNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])])], 1)], 1)], 1)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer negative-scenario"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 2 / Сообщение (При ответе Нет на Вопрос 1)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoText),
      expression: "scenario.parameters.questionSecondNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondNoId', 'questionSecondNoAudio', 'currentSpeakerSecondNo', 'questionSecondNoGeneratedAudio', 'questionSecondNoText', 'questionSecondNoLoading', 'Second no question', 'currentEmotionSecondNo', 'currentSpeedSecondNo')
      }
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.tmp.questionSecondNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNo),
      expression: "tmp.currentSpeakerSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNo),
      expression: "tmp.currentEmotionSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondNoLoadedAudio', 'questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', 'onQuestionSecondNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('collapse', [_c('collapse-item', {
    staticClass: "second-layer positive-scenario",
    attrs: {
      "title": "Сообщение при ответе Да на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondNoYesId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoYesGenerationState),
      expression: "scenario.parameters.questionSecondNoYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoYesGenerationState', 'questionSecondNoYesAudio', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesLoadedAudio', 'onQuestionSecondNoYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoYesGenerationState),
      expression: "scenario.parameters.questionSecondNoYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoYesGenerationState', 'questionSecondNoYesAudio', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesLoadedAudio', 'onQuestionSecondNoYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoYesText),
      expression: "scenario.parameters.questionSecondNoYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondNoYesId', 'questionSecondNoYesAudio', 'currentSpeakerSecondNoYes', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesText', 'questionSecondNoYesLoading', 'Second no yes question', 'currentEmotionSecondNoYes', 'currentSpeedSecondNoYes')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondNoYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNoYes),
      expression: "tmp.currentSpeakerSecondNoYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNoYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNoYes),
      expression: "tmp.currentEmotionSecondNoYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNoYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNoYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNoYes = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNoYes) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondNoYesLoadedAudio', 'questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'Second no yes question', 'onQuestionSecondNoYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'Second no yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'questionSecondNoYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])]), _vm._v(" "), _c('collapse-item', {
    staticClass: "second-layer negative-scenario",
    attrs: {
      "title": "Сообщение при ответе Нет на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondNoNoId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoNoGenerationState),
      expression: "scenario.parameters.questionSecondNoNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoNoGenerationState', 'questionSecondNoNoAudio', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoLoadedAudio', 'onQuestionSecondNoNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoNoGenerationState),
      expression: "scenario.parameters.questionSecondNoNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoNoGenerationState', 'questionSecondNoNoAudio', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoLoadedAudio', 'onQuestionSecondNoNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoNoText),
      expression: "scenario.parameters.questionSecondNoNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondNoNoId', 'questionSecondNoNoAudio', 'currentSpeakerSecondNoNo', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoText', 'questionSecondNoNoLoading', 'Second no no question', 'currentEmotionSecondNoNo', 'currentSpeedSecondNoNo')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondNoNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNoNo),
      expression: "tmp.currentSpeakerSecondNoNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNoNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNoNo),
      expression: "tmp.currentEmotionSecondNoNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNoNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNoNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNoNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNoNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondNoNoLoadedAudio', 'questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'Second no no question', 'onQuestionSecondNoNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'Second no no question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'questionSecondNoNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])])], 1)], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6d3fa54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/ScenarioTwoLevelYesNo.vue
// module id = 469
// module chunks = 40